import { useMemo } from 'react';
import { Tag } from 'antd';
import { 
  CheckCircleOutlined, 
  StopOutlined, 
  LogoutOutlined
} from '@ant-design/icons';

export const useUserStatusRender = () => {
  return useMemo(() => {
    return (status: string) => {
      const statusConfigs: {
        [key: string]: { color: string; icon: React.ReactNode; text: string };
      } = {
        ACTIVE: { color: 'success', icon: <CheckCircleOutlined />, text: 'Active' },
        INACTIVE: { color: 'default', icon: <StopOutlined />, text: 'Inactive' },
        RESIGNED: { color: 'warning', icon: <LogoutOutlined />, text: 'Resigned' },
      };

      const config = statusConfigs[status] || { color: 'default', icon: <StopOutlined />, text: status };
      
      return (
        <Tag color={config.color} icon={config.icon}>
          {config.text}
        </Tag>
      );
    };
  }, []);
};
